import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { environment } from '@stockcare-environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationModule } from '@stockcare-views/authentication/authentication.module';
import { JwtOptionsFactory } from '@stockcare-helpers/jwtOptionsFactory';
import { SharedModule } from '@stockcare-shared/shared.module';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { ConfigService } from '@stockcare-services/config-service/config.service';
import { LoaderInterceptor } from '@stockcare-shared/interceptors/loader.interceptor';
import { ApplicationInsightsService } from '@stockcare-services/application-insights/application-insights.service';
import { AlertModule } from 'ngx-bootstrap/alert';
import 'prevent-pull-refresh';
import { MessagesModule } from '@stockcare-views/messages/messages.module';
// import { NgxCsvParserModule } from 'ngx-csv-parser';


export function pollingServicesFactory(config: ConfigService) {
  return async () => {
    config.initialize();
  };
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        AuthenticationModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        SharedModule,
        // NgxCsvParserModule,
        AlertModule,
        ToastrModule.forRoot(),
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: JwtOptionsFactory,
            },
        }),
        MessagesModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
        })], providers: [
        ApplicationInsightsService,
        ConfigService,
        DeviceService,
        {
            provide: APP_INITIALIZER,
            useFactory: pollingServicesFactory,
            deps: [ConfigService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
